/**
 * Whether the app toolbar is shown for this route.
 * Keep in sync with Toolbar.vue (hideToolbarRoutes, setShow, $route watch).
 */
const HIDE_TOOLBAR_ROUTE_NAMES = [
  'Signin',
  'PassRecovery',
  'PassChange',
  'DashboardLiag',
  'LoadingScreen',
  'Welcome',
  'SharedPluviometricChart'
]

export function isToolbarVisibleForRoute (route) {
  if (!route) return false
  const name = route.name
  const path = route.path || ''
  const fullPath = route.fullPath || ''
  if (HIDE_TOOLBAR_ROUTE_NAMES.includes(name)) return false
  if (path.includes('/r/')) return false
  if (path === '/') return false
  if (fullPath.includes('loading')) return false
  return true
}



// WEBPACK FOOTER //
// ./src/lib/toolbarVisibility.js